module.exports = __webpack_public_path__ + "static/media/vidplus.d2acc2ba.png";